export class RawMaterial {
  constructor
    (
      {
        id = null,
        matCode = ``,
        matName = ``,
        curInventory = '',
        adjustTime = '',
      } = {}
    ) {
    this.id = id;
    this.matCode = matCode;
    this.matName = matName;
    this.curInventory = curInventory;
    this.adjustTime = adjustTime;
  }
}
export function gridFields() {
  return Object.freeze([
      {
        key: 'matCode',
        label: 'lbl.basic.matCode',
        sortable: true,
        form: {
          type: 'input'
        }
      },
      {
        key: 'matName',
        label: 'lbl.basic.matName',
        sortable: true,
        form: {
          type: 'input'
        }
      },
      {
        key: 'invCode',
        label: 'lbl.inventory.invCode',
        sortable: true,
        form: {
          type: 'input'
        }
      }, {
        key: 'invName',
        label: 'lbl.inventory.invName',
        sortable: true,
        form: {
          type: 'input'
        }
      },
      {
        key: 'curInventory',
        label: 'lbl.inventory.curInventory',
        sortable: true,
        form: {
          type: 'input'
        }
      }
    ]);
}
export const fields = Object.freeze(Object.keys(new RawMaterial()).map(i => 'entity.' + i));
export const filterFields =
  [

    'filter.matCodeFilter',
    'filter.invCodeFilter',
    'filter.invNameFilter',
  ];
export const filter =
{
  'matCodeFilter': "",
  'invCodeFilter': "",
  'invNameFilter': "",
};